import React, { useContext } from 'react'
import { Form, Pane } from '@leverege/ui-elements'
import { Attributes } from '@leverege/ui-attributes'
import ImageCapture from './ImageCapture'

export default function DefectImageEditor( props ) {
  const { context, eventData, attribute, object, onChange, } = props
  
  const delegate = context?.clientProps?.delegate
  
  /**
   * use on change instead of attribute 
   * call it with the event data passed here via props
   * 
   * add
   */

  const img = Attributes.get( 'defect.image', object )
  const shape = Attributes.get( 'defect.shape', object )

  return (
    <Pane layout="flex:colS">
      <ImageCapture
        value={img}
        delegate={delegate}
        shape={shape}
        eventData={eventData}
        onChange={onChange}
        attr={attribute}
        target={object}/>
    </Pane>
  )
}
